import { Download, Loader2, X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type DownloadUrlFormProps = {
  url: string
  onUrlChange: (url: string) => void
  onDownload: (e?: React.MouseEvent) => void
  onCancel: () => void
  isDownloading: boolean
  placeholder?: string
}

export const DownloadUrlForm = ({
  url,
  onUrlChange,
  onDownload,
  onCancel,
  isDownloading,
  placeholder = 'URLを入力',
}: DownloadUrlFormProps) => {
  return (
    <div className="flex gap-2">
      <Input
        type="url"
        placeholder={placeholder}
        value={url}
        onChange={(e) => onUrlChange(e.target.value)}
        disabled={isDownloading}
      />
      <Button onClick={onDownload} disabled={isDownloading || !url.trim()}>
        {isDownloading ? <Loader2 className="animate-spin" size={20} /> : <Download size={20} />}
      </Button>
      {isDownloading && (
        <Button variant="destructive" onClick={onCancel}>
          <X size={20} />
        </Button>
      )}
    </div>
  )
}
